import { createFileRoute, Navigate } from '@tanstack/react-router';
import React from 'react';

import { isGameplayHistoryReplayEnabled } from '~/app/config';
import { ROUTE_404 } from '~/app/routes';
import SnapshotReplayPage from '~/pages/snapshots/[id]';

export const Route = createFileRoute('/snapshots/$id')({
  component: SnapshotReplayRoute,
});

function SnapshotReplayRoute() {
  if (!isGameplayHistoryReplayEnabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <SnapshotReplayPage />;
}
